// TODO: Find a better way to accomplish this
import { SET_BACK_BUTTON } from '@/utils/store/mutationTypes'

export default function ({ store }) {
  // By default the back button should not be visible.
  if (store.state.app.backButton.visible) {
    store.commit(`app/${SET_BACK_BUTTON}`, {
      visible: false,
      text: null,
      to: null
    })
  }
}
